import EmptyAnswer from "./EmptyAnswer";
import { EqualAnswer } from "./EquealAnswer";
import { OrderAnswer } from "./OrderAnswer";
import { Type1 } from "./Type1";
import {useState} from "react";
import ExplanationAnswer from "./ExplanationAnswer";
import Table from "./Table";

export function AnswerField({change, id, typeId, deleteHandler ,defaultValue}) {
  const [isActive,setIsActive]=useState(true)
  function deleteAnswersFiled(id){
    deleteHandler(id);
    setIsActive(false)
  }
  switch(typeId) {
    case "3": return 
    case "5": return  isActive?<EqualAnswer defaultValue={defaultValue} id={id} change={change} deleteHandler={deleteAnswersFiled}/>:null
    case "6": return <EmptyAnswer defaultValue={defaultValue} id={id} change={change}/>
    case "7": return isActive?<OrderAnswer defaultValue={defaultValue} id={id} change={change} deleteHandler={deleteAnswersFiled}/>:null
    case "8": return isActive?<ExplanationAnswer defaultValue={defaultValue} id={id} change={change} deleteHandler={deleteAnswersFiled}/>:null
    case "9": return <EmptyAnswer defaultValue={defaultValue} id={id} change={change}/>
      case "10": return <Table defaultValue={defaultValue} id={id} change={change}/>

    default: return isActive?<Type1 defaultValue={defaultValue} id={id} change={change} deleteHandler={deleteAnswersFiled}/>:null
  }
}